import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TopBar } from "@/components/layout/TopBar";
import { SiteFooter } from "@/components/layout/SiteFooter";
import { StickyContact } from "@/components/site/StickyContact";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { JsonLd, localBusinessSchema } from "@/components/site/Seo";
import { AUDIENCES, PROGRAMME_PATH } from "@/lib/content";
import Home from "@/routes/Home";
import About from "@/routes/About";
import Programme from "@/routes/Programme";
import AudiencePage from "@/routes/AudiencePage";
import HowItWorks from "@/routes/HowItWorks";
import Stories from "@/routes/Stories";
import FaqPage from "@/routes/FaqPage";
import Contact from "@/routes/Contact";
import Privacy from "@/routes/Privacy";
import NotFound from "@/routes/NotFound";

function Layout() {
  return (
    <>
      <SmoothScroll />
      <JsonLd id="local-business" data={localBusinessSchema()} />
      <TopBar />
      <main>
        <Outlet />
      </main>
      <SiteFooter />
      <StickyContact />
      <Toaster position="top-center" richColors />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path={PROGRAMME_PATH} element={<Programme />} />
          {AUDIENCES.map((a) => (
            <Route key={a.slug} path={`/${a.slug}`} element={<AudiencePage audience={a} />} />
          ))}
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/success-stories" element={<Stories />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
